export const BREAKPOINT_WIDTH = 768
